import { IconButton, Tooltip, Typography } from "@mui/material";
import { useCustomMutation } from "@refinedev/core";
import { useQueryClient } from "@tanstack/react-query";
import { useMarketplaceStore } from "../../store/useMarketplaceStore";
import { useCurrency, CurrencyDisplay } from "../../hooks/useCurrency";

export const CurrencyToggle = () => {
  const selectedCountry = useMarketplaceStore((s) => s.selectedCountry);
  const { isUSD, isLoading, settings } = useCurrency();
  const { mutate, isLoading: isSaving } = useCustomMutation();
  const queryClient = useQueryClient();

  if (!selectedCountry) return null;

  const localSymbol = selectedCountry.currency;
  if (!localSymbol || localSymbol === "$") return null;

  if (isLoading || !settings) return null;

  const nextValue: CurrencyDisplay = isUSD ? "LOCAL_CURRENCY" : "USD";

  const handleClick = () => {
    if (isSaving) return;

    mutate(
      {
        url: `store/${selectedCountry.id}/settings`,
        method: "put",
        values: {
          ...settings,
          currencyDisplay: nextValue,
        },
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries();
        },
      },
    );
  };

  let tooltipTitle: string;
  if (isSaving) {
    tooltipTitle = "Kaydediliyor...";
  } else if (isUSD) {
    tooltipTitle = `Yerel para birimine geç (${localSymbol})`;
  } else {
    tooltipTitle = "USD'ye geç ($)";
  }

  return (
    <Tooltip title={tooltipTitle}>
      <span>
        <IconButton
          color="inherit"
          onClick={handleClick}
          disabled={isSaving}
          aria-label="Para birimi değiştir"
          sx={{ width: 34, height: 34 }}
        >
          <Typography fontSize="1rem" fontWeight={700} lineHeight={1}>
            {isUSD ? "$" : localSymbol}
          </Typography>
        </IconButton>
      </span>
    </Tooltip>
  );
};
